import { render, staticRenderFns } from "./CuentaPaquete.vue?vue&type=template&id=214ebd1f&scoped=true"
import script from "./CuentaPaquete.vue?vue&type=script&lang=js"
export * from "./CuentaPaquete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ebd1f",
  null
  
)

export default component.exports